import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { KpisView } from '@/features/clients/KpisView'

function KpisRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <KpisView companyId={companyId} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/kpis')({ component: KpisRoute })
